import styled from 'styled-components';

export const Container = styled.section`
  width: 100%;
  max-width: 100vw;

  margin-top: 60px;

  display: flex;
  justify-content: center;

  padding: 40px 0;

  border: 1px solid
    ${({ theme }) => theme.aplicativos.novosAplicativos.bottomBorder};

  @media (max-width: 1088px) {
    padding: 40px 30px;
  }

  @media (max-width: 500px) {
    padding: 40px 20px;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  max-width: 700px;

  display: flex;
  align-items: center;

  gap: 32px;

  p {
    font-size: 18px;
    line-height: 28px;
  }

  img {
    border-radius: 22px;

    box-shadow: 0px 10px 20px #c1c1c180;
  }

  @media (max-width: 750px) {
    p {
      font-size: 16px;
      line-height: 24px;
    }
  }

  @media (max-width: 450px) {
    p {
      font-size: 14px;
      line-height: 22px;
    }
  }

  @media (max-width: 415px) {
    gap: 16px;
    img {
      width: 70px;
    }
  }
`;
